<template lang="pug">
  .card.height-100
    .card-body
      .columns
        .column.col-12.text-ellipsis Código: #[span.text-bold {{ coupon.code }}]
        .column.col-12.text-ellipsis(v-if="coupon.amount") Restante: #[span.text-bold {{ coupon.amount }}]
        .column.col-12.text-ellipsis(v-if="coupon.expiresIn") Expira em: #[span.text-bold {{ coupon.expiresIn | toDate('DD/MM/YYYY') }}]
        .column.col-12.text-ellipsis Tipo de desconto: #[span.text-bold(:class="discountType.class") {{ discountType.label }}]
        .column.col-12.text-ellipsis Valor: #[span.text-bold(:class="discountType.class") {{ coupon.value | currency(...discountType.filter) }}]
        .column.col-12.text-ellipsis Criador: #[span.text-bold {{ coupon.creator.fullName }}]
    .card-footer
      .columns.align-center
        .column
          .text-small Adicionado em #[span.text-bold {{ coupon.createdAt | toDate('DD/MM/YYYY') }}]
        .column.col-auto
          a.btn.btn-action.btn-sm.text-error.btn-link.tooltip(
            data-tooltip="Excluir"
            @click="$emit('remove', coupon)"
          )
            i.fas.fa-trash-alt
          router-link.btn.btn-action.btn-sm.btn-link.tooltip(
            :to="{ name: 'coupons.edit', params: { id: coupon.id } }"
            data-tooltip="Editar"
          )
            i.fas.fa-edit
</template>

<script>
import { discountTypes } from '@/lib/constants'

export default {
  props: { coupon: { type: Object, required: true } },
  computed: {
    discountType() {
      return discountTypes[this.coupon.discountType]
    },
  },
}
</script>
